import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Grid, IconButton, Tooltip, tooltipClasses, Typography } from "@mui/material"
import { ButtonBasic, TableBase } from "../../components"
import FechaFunction from "../../function/FechaFunction";
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import MedicalServicesIcon from '@mui/icons-material/MedicalServices';
import { styled } from '@mui/material/styles';
import ConsultasService from "../../services/consultas.service";
import EquipamientoTkService from "../../services/equipamiento-ticket.service";
import { showModal } from "react-redux-modal-provider";
import ModalHistorialEquipoSoftland from "../../modals/softland/ModalHistorialEquipoSoftland";

const LightTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: theme.palette.common.white,
        color: 'rgba(0, 0, 0, 0.87)',
        boxShadow: theme.shadows[1],
        fontSize: 12,
    },
}));
const EquipamientoScreen = () => {
    const [items, setItems] = useState([]);
    const navigate = useNavigate();

    const actualizar = async () => {
        await EquipamientoTkService.getAll({ all: 'multi' }).then((r)=>{
            setItems(r)
        })
    };
    const onOpenModalHistory = async(idMAc) => {
        const limpiarText = idMAc?.replaceAll(':','')?.replaceAll(' ','')
        await EquipamientoTkService.getHistory(limpiarText).then((resp)=>{
            showModal(ModalHistorialEquipoSoftland,{items: resp, idRegistrado: idMAc})
        });
    };

    const columns = [
        {
            name: "id_eqt",
            label: "ID",
            options: {
                filter: false,
                sort: false,
                display:false,
                viewColumns: false
            }
        },
        {
            name: "createdAt",
            label: "Registrado",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    return FechaFunction.format(new Date(value),'dd/MM/yyyy HH:mm');
                }
            }
        },
        {
            label: "Nombre",
            name: "nombreEquipo_eqt",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            label: "Mac",
            name: 'macEquipo_eqt',
            options: {
                filter: false,
                sort: false,
                customBodyRender: (value, tableMeta, updateValue) => {
                    if(!value) return <Typography sx={{color: '#000'}}>-</Typography>
                    return (
                        <Typography
                            sx={{
                                color: '#15294b',fontWeight: 'bold',fontSize: 12,
                                '&:hover':{cursor: 'pointer', color: '#0364ff'}
                            }}
                            onClick={()=> onOpenModalHistory(value)}
                        >
                            {value}
                        </Typography>
                    )
                }
            }
        },
        {
            label: 'SN',
            name: 'snEquipo_eqt',
            options: {
                filter: false,
                sort: false,
                customBodyRender: (value, tableMeta, updateValue) => {
                    if(!value) return <Typography sx={{color: '#000'}}>-</Typography>
                    return (
                        <Typography
                            sx={{
                                color: '#15294b',fontWeight: 'bold',fontSize: 12,
                                '&:hover':{cursor: 'pointer', color: '#0364ff'}
                            }}
                            onClick={()=> onOpenModalHistory(value)}
                        >
                            {value}
                        </Typography>
                    )
                }
            }
        },
        {
            label: 'Ticket',
            name: 'ticketId_eqt',
            options: {
                customBodyRender: (value, tableMeta, updateValue) => {
                    if(!value) return <Typography sx={{color: '#000'}}>-</Typography>
                    return (
                        <Typography
                            sx={{
                                color: '#15294b',fontWeight: 'bold',fontSize: 12,
                                '&:hover':{cursor: 'pointer', color: '#0364ff'}
                            }}
                            onClick={()=> navigate(`/ticket/${value}/nubicom`)}
                        >
                            {value}
                        </Typography>
                    )
                }
            }
        },
        {
            label: 'Servicio',
            name: 'servicioId_eqt',
            options: {
                customBodyRender: (value, tableMeta, updateValue) => {
                    if(!value) return <Typography sx={{color: '#000'}}>-</Typography>
                    return (
                        <Typography
                            sx={{
                                color: '#15294b',fontWeight: 'bold',fontSize: 12,
                                '&:hover':{cursor: 'pointer', color: '#0364ff'}
                            }}
                            onClick={()=> navigate(`/pre-servicio/${value}/nubicom`)}
                        >
                            {value}
                        </Typography>
                    )
                }
            }
        },
    ];
    useEffect(() => {
        actualizar()
        document.title = `Equipamiento Servicio`;
    }, [])

    return (
        <Box sx={{width:'100%',height: '100%',overflow:'auto'}} className='side'>
            <Grid container p={4}>
                <Grid item xs={12} md={6} lg={6}>
                    <Typography className="text-gray-900 font-bold" variant="h2">Equipamientos Servicios</Typography>
                </Grid>
                <Grid item xs={12} sx={{marginBottom: 15}}>
                    <TableBase title='Resultados' columns={columns} data={items} />
                </Grid>
            </Grid>
        </Box>
    )
}

export default EquipamientoScreen;